module.exports = __webpack_public_path__ + "img/sixpackcarrier74.97c71571.jpg";